import { render } from "./SalariesPanel.vue?vue&type=template&id=7e7f4c12"
import script from "./SalariesPanel.vue?vue&type=script&lang=js"
export * from "./SalariesPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__